export default __webpack_public_path__ + "static/media/img3.e0593d91.jpg";